import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCodeBranch } from '@fortawesome/free-solid-svg-icons';
import './AppVersion.css';

/* =========================================================
   "Website version" on the admin student / teacher profile.
   Their version comes from their heartbeat (REACT_APP_VERSION, the one in the console);
   the latest one is the site's /meta.json (what the site reloads to). Old = they still have an old page open
   (or the reload hasn't happened yet).
   role: 'student' | 'teacher'
   ========================================================= */
const API = process.env.REACT_APP_API_BASE_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('userData')}` } });

const when = (v) => {
  const d = v ? new Date(v) : null;
  if (!d || Number.isNaN(d.getTime())) return '';
  const min = Math.floor((Date.now() - d.getTime()) / 60000);
  if (min < 2) return 'just now';
  if (min < 60) return `${min} min ago`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h ago`;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'Asia/Beirut' });
};

const AppVersion = ({ role, id }) => {
  const [mine, setMine] = useState(null);
  const [latest, setLatest] = useState(process.env.REACT_APP_VERSION || null);

  useEffect(() => {
    let alive = true;
    const path = role === 'teacher' ? 'teacherProfile' : 'studentprofile';
    axios
      .get(`${API}/api/admin/${path}/appversion/${id}`, auth())
      .then((r) => alive && setMine(r.data || { version: null }))
      .catch(() => alive && setMine({ version: null, failed: true }));
    fetch('/meta.json', { cache: 'no-store' })
      .then((r) => r.json())
      .then((m) => alive && m?.version && setLatest(m.version))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [role, id]);

  if (!mine || mine.failed) return null;
  const status = !mine.version ? 'none' : latest && mine.version === latest ? 'ok' : 'old';

  return (
    <span className={`rmappv is-${status}`} title={mine.at ? `Checked ${when(mine.at)}` : undefined}>
      <FontAwesomeIcon icon={faCodeBranch} />
      {status === 'none' ? (
        'Version: not seen yet'
      ) : (
        <>
          v{mine.version}
          <b>{status === 'ok' ? 'Latest' : `Old · latest v${latest}`}</b>
          {mine.at && <small>{when(mine.at)}</small>}
        </>
      )}
    </span>
  );
};

export default AppVersion;
